module.exports = __webpack_public_path__ + "static/media/tshirt.095546b0.svg";